// src/components/Navbar.jsx
import { useMemo } from "react";
import { useLocation, Link } from "react-router-dom";

export default function Navbar() {
  const location = useLocation();

  // Legal sayfalar
  const isLegalPage = useMemo(() => {
    return (
      location.pathname.startsWith("/kvkk") ||
      location.pathname.startsWith("/gizlilik") ||
      location.pathname.startsWith("/kullanim-kosullari")
    );
  }, [location.pathname]);

  // Destek sayfası
  const isSupportPage = location.pathname.startsWith("/destek");

  return (
    <nav className="fixed left-0 top-0 z-50 flex w-full items-center justify-between border-b border-gray-200 bg-white px-6 py-4 md:px-12">
      {/* Logo */}
      <Link
        to="/"
        className="text-2xl font-extrabold text-black transition hover:opacity-80 md:text-3xl"
      >
        KolayYük
      </Link>

      {/* Landing sayfası menü */}
      {!isSupportPage && !isLegalPage && (
        <div className="hidden items-center gap-8 font-medium text-gray-700 md:flex">
          <a href="#who" className="transition hover:text-black">
            Kimler İçin?
          </a>

          <a href="#how" className="transition hover:text-black">
            Nasıl Çalışır
          </a>

          <a href="#faq" className="transition hover:text-black">
            SSS
          </a>

          <Link
            to="/indir"
            className="rounded-md bg-black px-5 py-2 font-semibold text-white transition hover:opacity-90"
          >
            Uygulamayı İndir
          </Link>
        </div>
      )}

      {/* Legal sayfalar */}
      {!isSupportPage && isLegalPage && (
        <div className="text-sm text-gray-500">Bilgilendirme Sayfası</div>
      )}
    </nav>
  );
}